import {StyleSheet, Text, View, ViewStyle} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    title: string,
    color: string,
    contrastColor: string,
    round?: boolean,
    size?: number,
}

export default function Badge({title, color, round, contrastColor, size}: Props) {
    const roundStyle: ViewStyle = round ? {
        borderRadius: 64,
        minWidth: size || 22,
        height: size || 22,
        paddingVertical: 0,
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
    } : {};
    return (
        <View style={[styles.badge, roundStyle, {backgroundColor: color}]}>
            <Text style={[styles.text, {color: contrastColor}]} selectable={false}>
                {title}
            </Text>
        </View>
    )
}

export const styles = StyleSheet.create({
    badge: {
        backgroundColor: Color.Yellow,
        borderRadius: 4,
        paddingVertical: 4,
        paddingHorizontal: 5,
        flexShrink: 1,
    },
    text: {
        color: Color.Background,
        fontSize: 12,
        fontWeight: 600,
    },
})